import { ofType } from 'redux-observable';
import { mapTo, filter } from 'rxjs/operators';

import { SET_CONSULTATION_ESTABLISHED } from '../actions/consultationLifecycle';
import createAction from '../actions';

export const START_CONSULTATION_TIMER = createAction('START_CONSULTATION_TIMER');
export const STOP_CONSULTATION_TIMER = createAction('STOP_CONSULTATION_TIMER');

export const clearConsultationTimer = () => ({ type: STOP_CONSULTATION_TIMER });

export const startConsultationTimerAction = (dispatch, getState) => {
  const state = getState();
  const { channel } = state.conference.consultationParams;

  return dispatch({
    type: START_CONSULTATION_TIMER,
    payload: { channel },
  });
};

export const startConsultationTimer = (action$, store$) =>
  action$
    .pipe(
      ofType(SET_CONSULTATION_ESTABLISHED),
      filter(() => {
        const state = store$.getState();
        const { consultationStartedTime, channel } = state.conference.consultationStats;
        const { channel: conferenceChannel } = state.conference.consultationParams;

        return !consultationStartedTime || (channel && channel !== conferenceChannel);
      }),
      mapTo(startConsultationTimerAction),
    );
